import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {
    ButtonAction,
    Container,
    ContainerActionButtons, ContainerCompactMode, ContentButton
} from "@dropDesk/presentation/components/internal_chat_view/header_action_buttons/styled";
import {Brightness} from "@dropDesk/domain/entities/theme/colors.entity";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import React from "react";
import {Tooltip} from "antd";
import {getInfoCompactModeMessages} from "@dropDesk/utils/helpers/common";
import {useBetween} from "use-between";
import {useModalChat} from "@dropDesk/presentation/pages/chat/ui/modals/visible_modal_search";


const HeaderActionButtons = observer(
    ({
         canChange,
         canChangeDelete,
         compactModeMessages,
         setCompactModeMessage,
         onClickDelete
     }: {
        canChange: boolean
        canChangeDelete: boolean
        compactModeMessages: boolean
        setCompactModeMessage: (value: boolean) => void
        onClickDelete: () => void
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const {
            setVisibleModalListInternalChatUsers
        } = useBetween(useModalChat);

        return (
            <Container>
                <ContainerActionButtons>
                    <Tooltip title={'Atendentes participantes do chat interno'}>
                        <ContentButton disable={!canChange}>
                            <ButtonAction
                                border={colors.border}
                                accent={colors.accent}
                                onClick={() => setVisibleModalListInternalChatUsers(true)}
                                isDarkTheme={colors.brightness === Brightness.dark}
                                disabled={!canChange}
                                width={135}
                                color={colors.text}
                                background={colors.backgroundInput}
                            >
                                <DropDeskIcon icon={ICONS_DROPDESK.customer} size={16}/>
                                Participantes
                            </ButtonAction>
                        </ContentButton>
                    </Tooltip>
                </ContainerActionButtons>
                <ContainerCompactMode>
                    <Tooltip title={canChangeDelete ? 'Excluir chat interno' : 'Somente o criador pode excluir'}>
                        <ContentButton disable={!canChangeDelete}>
                            <ButtonAction
                                style={{justifyContent: 'center', padding: 0}}
                                border={colors.border}
                                accent={colors.accent}
                                onClick={onClickDelete}
                                isDarkTheme={colors.brightness === Brightness.dark}
                                disabled={!canChangeDelete}
                                width={35}
                                color={colors.text}
                                background={colors.backgroundInput}
                            >
                                <DropDeskIcon icon={ICONS_DROPDESK.delete} color={colors.textError} size={16}/>
                            </ButtonAction>
                        </ContentButton>
                    </Tooltip>
                    <Tooltip title={getInfoCompactModeMessages(compactModeMessages).tooltip}>
                        <ContentButton disable={false}>
                            <ButtonAction
                                border={colors.border}
                                accent={colors.accent}
                                onClick={() => setCompactModeMessage(!compactModeMessages)}
                                isDarkTheme={colors.brightness === Brightness.dark}
                                disabled={false}
                                width={110}
                                color={colors.text}
                                background={colors.backgroundInput}
                            >
                                <DropDeskIcon
                                    icon={`${compactModeMessages ? ICONS_DROPDESK.reduce : ICONS_DROPDESK.stretch}`}
                                    size={12}
                                />
                                {getInfoCompactModeMessages(compactModeMessages).labelButton}
                            </ButtonAction>
                        </ContentButton>
                    </Tooltip>
                </ContainerCompactMode>
            </Container>
        );
    });
export default HeaderActionButtons;